import { React, useState, useEffect, useRef } from "react";
import { Helmet } from "react-helmet-async";
import Header from "../../components/header/Header";
import Footer from "../../components/footer/Footer";
import Slideshow from "../../components/slideshow/Slideshow";
import { getEssentialProducts } from "../../constants/essential_products";
import { main_paige_title } from "../../constants/constants";
import HomeMiniSlideshow from "../../components/slideshow/HomeMiniSlideshow.js";
import EssentialProductsSection from "../../components/product/EssentialProductsSection";
import FeedbackSlideshow from "../../components/slideshow/FeedbackSlideshow";
import SocialSlideshow from "../../components/slideshow/SocialSlideshow.js";

const Home = () => {
  const targetRef = useRef();
  const [essentialProducts, setEssentialProducts] = useState([]);

  useEffect(() => {
    setEssentialProducts(getEssentialProducts());
  }, []);

  return (
    <div>
      <Helmet>
        <title property="title">{main_paige_title} - Startseite</title>
      </Helmet>
      <Header />
      <main id="content1" ref={targetRef}>
        <Slideshow />
        <section class="py-11 pt-lg-13 pb-lg-15">
          <div class="container">
            <div class="mxw-110px mx-auto mb-8">
              <img src="/luminit-logo-single.jpg" alt="Logo" />
            </div>
            <div class="mxw-924 mx-auto">
              <h4 class="fs-30 fs-md-40 lh-15 mb-10 mb-lg-12 text-center">
              Zeitlose Eleganz für dein Zuhause
              </h4>
              <p className="text-center">
              Diese eleganten Regalsysteme verbinden modernes Design mit Funktionalität. Sie bieten stilvollen Stauraum und setzen dekorative Akzente, perfekt für Bücher, Kunst oder Alltagsgegenstände. Ihre klare Formensprache fügt sich harmonisch in jedes Interieur ein.
              </p>
            </div>
          </div>
          <HomeMiniSlideshow />
        </section>

        <EssentialProductsSection products={essentialProducts} />
        <FeedbackSlideshow />
        <SocialSlideshow />
      </main>
      <Footer />
    </div>
  );
};

export default Home;